import { validate, createValidationSchema } from "@";

export const multiSendSchema = createValidationSchema({
  category: validate("req", "category"),
  messageBody: validate("req", "messageBody"),
  messageType: validate("number", "messageType"),
  projectAmount: validate("req", "projectAmount"),
});

export const singleSendSchema = createValidationSchema({
  message: validate("req", "message"),
  phone: validate("nullablePhone", "phone"),
});

export const multiSendDefaultValues = {
  category: 0,
  isPaid: null,
  toTime: null,
  messageType: 0,
  fromTime: null,
  messageBody: "",
  projectId: null,
  projectAmount: 0,
  giftProjectId: null,
  classificationId: null,
};

export const singleSendDefaultValues = {
  message: "",
  phone: "",
};
